import { Action, ActionReducerMap, createReducer, on } from '@ngrx/store';

import { Manager, retrieve } from '@app/shared';
import { sortParameters } from '@modules/companies/filter/components/sort-selector/companies-sort-selector.component';
import { Pagination, paginationReducer } from '@shared/pagination';
import { SortParameter } from '@shared/sort-selector/sort-parameter';

import * as CompaniesPageActions from './companies-page.actions';
import { companiesPageSetFilter } from './companies-page.actions';

export interface CompaniesPageFilterState {
  sortBy: SortParameter;
  name?: string;
}

export interface CompaniesPageDetailsState {
  loaded: boolean;
  loading: boolean;
}

export interface CompanyManagers {
  list: Pagination<Manager>;
  isLoading: boolean;
}

export interface CompaniesPageState {
  companies: Pagination;
  jobsPerCompany: Pagination;
  managersPerCompany: CompanyManagers;
  pageDetails: CompaniesPageDetailsState;
  filter: CompaniesPageFilterState;
}

export const initialState: CompaniesPageDetailsState = {
  loaded: false,
  loading: false,
};

export const filtersInitialState: CompaniesPageFilterState = {
  sortBy: sortParameters[0],
};

export const companyManagersInitialState: CompanyManagers = {
  list: null,
  isLoading: false,
};

export const COMPANIES_PAGE_TOKEN = 'companiesPage';
export const COMPANIES_PAGE_FILTER_TOKEN = 'companiesPageFilter';

export const companiesPaginationReducers: ActionReducerMap<CompaniesPageState, Action> = {
  companies: paginationReducer(CompaniesPageActions.companiesLoadPageSuccess.type),
  jobsPerCompany: paginationReducer(CompaniesPageActions.companiesLoadJobsPerCompanySuccess.type),
  pageDetails: createReducer(
    initialState,
    on(CompaniesPageActions.companiesLoadPage, (state) => ({ ...state, loading: true })),
    on(CompaniesPageActions.companiesLoadPageSuccess, (state) => ({
      ...state,
      loaded: true,
      loading: false,
    })),
    on(CompaniesPageActions.companiesLoadPageFail, (state) => ({
      ...state,
      loaded: false,
      loading: false,
    })),
  ),
  filter: createReducer(
    retrieve(COMPANIES_PAGE_FILTER_TOKEN, filtersInitialState),
    on(companiesPageSetFilter, (state, { payload }) => ({
      ...state,
      ...payload,
    })),
  ),
  managersPerCompany: createReducer(
    companyManagersInitialState,
    on(CompaniesPageActions.loadManagersPerCompany, (state) => ({ ...state, isLoading: true })),
    on(CompaniesPageActions.loadManagersPerCompanySuccess, (state, action) => ({
      ...state,
      list: action.managersPerCompany,
      isLoading: false,
    })),
    on(CompaniesPageActions.loadManagersPerCompanyFailure, (state, { error }) => ({
      ...state,
      error,
      isLoading: false,
    })),
    on(CompaniesPageActions.updateManagerPerCompanySuccess, (state, { manager }) => {
      const updatedList = state.list.content.map((sp) => (sp.id === manager.id ? manager : sp));
      return { ...state, list: { ...state.list, content: updatedList } };
    }),
  ),
};
